module.exports = __webpack_public_path__ + "static/media/G1141311_Korea-09.8c44cceb.png";